

import { Allroutes } from './Allroutes';
import './App.css';

import { AllProducts } from './pages/AllProducts';

import { ProductImages } from './pages/ProductImage';
// import { Admin } from './Components/Admin/Admin';

// import Signup from './Components/LoginAuth/Signup';

// import Signup from './Components/LoginAuth/Signup';

function App() {
  return (
    <div className="App">

      <Allroutes />

      
     {/* <Admin />  */}
      
      {/* <Signup/> */}
    </div>
  );
}

export default App;
